import React from 'react';
import { Box } from '../Box';
import { Space } from '../Space';
const alignmentOpts = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
};
const Stack = ({ children, space, align = 'left', containerWidth, className, }) => {
    const alignItems = alignmentOpts[align];
    const filteredChildren = React.Children.toArray(children).filter(Boolean);
    return (React.createElement(Box, { display: "flex", flexDirection: "column", alignItems: alignItems, width: containerWidth, className: className, "data-testid": "mui-stack-container" }, React.Children.map(filteredChildren, (child, i) => {
        const clonedChild = React.cloneElement(child, { align });
        if (i === 0) {
            return clonedChild;
        }
        return React.createElement(Space, { mt: space }, clonedChild);
    })));
};
export { Stack };
//# sourceMappingURL=Stack.js.map